import Vue from 'vue'
import Router from "vue-router";
import JsonExcel from 'vue-json-excel'
import HelloWorld from "@/components/views/HelloWorld";
import {listConfig} from "@/config/bsn";
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import jb from "@/components/views/hsmj/jb";
import axios from 'axios';
import jbList from "@/components/views/hsmj/jbList";

Vue.prototype.listConfig=listConfig
Vue.component('downloadExcel', JsonExcel)

Vue.use(Router)
Vue.use(Element)
Vue.prototype.$axios=axios

export default new Router({
  routes: [
    {
      path: '/jb',
      name: 'jb',
      component: jb
    },
    {
      path: '/list',
      name: 'list',
      component: jbList
    },
    {
      path: '/',
      name: 'hello',
      component: HelloWorld
    }
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js